import {
    useEffect, useState,
} from 'react';
import { Box } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import _ from 'lodash';

import { UserActions } from 'BMapsCmds';
import { useDispatch, useSelector } from 'BMapsRedux';
import { lookupJobDefinition } from 'BMapsSrc/jobs/JobDefinition';
import { updateDisplayedCompoundJobs } from 'BMapsRedux/jobs/access';
import DialogContentSection from 'BMapsUI/common/DialogContentSection';
import BMapsTooltip from 'BMapsUI/BMapsTooltip';
import LoadingIconButton from 'BMapsUI/common/LoadingIconButton';
import { fetchJobs } from 'BMapsRedux/jobs/thunks';
import { ensureArray } from 'BMapsSrc/util/js_utils';
import { JobsGrid } from '../../ImportProteinPane/Tabs/JobsStructuresTab';

export function JobsCompoundsTab({ initData, selected }) {
    const {
        jobs, status, localJobState,
    } = useSelector((state) => state.jobs);
    const setActiveJobs = (jobList) => {
        updateDisplayedCompoundJobs(ensureArray(jobList));
        UserActions.OpenImport('jobs_compounds_results_tab', { jobid: jobList });
    };
    const dispatch = useDispatch();
    const retrieveJobs = () => dispatch(fetchJobs());
    const highlightedJob = initData?.jobid;
    const [flashId, setFlashId] = useState(null);
    const [errors, setErrors] = useState([]);

    const loadJobsList = async () => {
        const { error } = await retrieveJobs();
        if (error) {
            setErrors([error]);
        } else {
            setErrors([]);
        }
    };

    useEffect(() => {
        if (status === 'unloaded') {
            loadJobsList();
        }
    }, [status]);

    // Animates the flash when a new job is created, so that it can be easily visible
    useEffect(() => {
        if (!highlightedJob) return () => null;
        setFlashId(highlightedJob);

        const timer = setTimeout(() => setFlashId(null), 500);
        return () => {
            clearTimeout(timer);
        };
    }, [highlightedJob]);

    if (!selected) return null;
    const myJobs = jobs.filter((job) => lookupJobDefinition(job.jobtype)?.loadsCompound);

    return (
        <Box sx={{
            display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflow: 'hidden',
        }}
        >
            <DialogContentSection
                title="Compound Generation Jobs"
                style={{
                    display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflow: 'hidden',
                }}
                contentStyle={{
                    display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden',
                }}
                titleIcon={(
                    <BMapsTooltip title="Refresh Jobs List">
                        <LoadingIconButton Icon={RefreshIcon} load={loadJobsList} />
                    </BMapsTooltip>
                )}
            >
                <JobsGrid
                    jobs={myJobs}
                    localJobState={localJobState}
                    cleanup={() => {}}
                    flashId={flashId}
                    errors={errors}
                    setActiveJobs={setActiveJobs}
                />
            </DialogContentSection>
        </Box>
    );
}
